import FadeContent from '../reactbits/FadeContent';

const STEPS = [
  { sym: 's-diagnose', no: '01', title: '测评诊断', tag: '定位五层成熟度', desc: '识别管理者在五层领导力中的成熟阶段。' },
  { sym: 's-read', no: '02', title: '结果解读', tag: '看清优势与短板', desc: '判断个人优势、薄弱层级与团队结构缺口。' },
  { sym: 's-grow', no: '03', title: '分层培养', tag: '匹配不同管理层级', desc: '面向一线管理者、部门负责人、高层管理者设计培养路径。' },
  { sym: 's-talent', no: '04', title: '人才决策', tag: '支持选拔与任用', desc: '支持晋升评估、高潜识别与关键岗位任用。' },
];

const VALUES = [
  { sym: 's-diagnose', t: '科学决策', s: '数据驱动，减少主观判断' },
  { sym: 's-ph2', t: '精准匹配', s: '人岗匹配，发挥管理效能' },
  { sym: 's-book', t: '持续成长', s: '闭环培养，能力持续进阶' },
  { sym: 's-gov', t: '组织增值', s: '构建高 AI 领导力组织' },
];

export default function DecisionFlow() {
  return (
    <section className="flow-sec">
      <div className="flow-wrap">
        <FadeContent className="head flow-head">
          <span className="kicker">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="9" /><path d="M12 12V7M12 12l4 2" /></svg>
            结果应用
          </span>
          <h2 className="section-title">让测评结果进入管理决策</h2>
          <p className="section-sub">从能力诊断、团队盘点到培养选拔，帮助企业系统提升管理团队的 AI 领导力。</p>
        </FadeContent>

        <div className="steps">
          <div className="flow-line" aria-hidden="true">
            <svg viewBox="0 0 1000 48" preserveAspectRatio="none">
              <path d="M0 24 C 110 -6, 190 54, 300 24 S 530 -6, 640 24 S 870 54, 1000 24" fill="none" stroke="#b9a8f4" strokeWidth="2.4" strokeDasharray="2 9" strokeLinecap="round" />
              <path d="M978 14 L1000 24 L978 34" fill="none" stroke="#7c5cff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          {STEPS.map((s, i) => (
            <FadeContent className="step" delay={i * 90} key={s.no}>
              <span className="step-icon"><svg><use href={`#${s.sym}`} /></svg></span>
              <div className="step-card">
                <span className="step-badge mono">{s.no}</span>
                <h4>{s.title}</h4>
                <span className="step-tag">{s.tag}</span>
                <p>{s.desc}</p>
              </div>
            </FadeContent>
          ))}
        </div>

        <div className="value-bar">
          {VALUES.map((v) => (
            <div className="value-item" key={v.t}>
              <span className="ic"><svg><use href={`#${v.sym}`} /></svg></span>
              <span><span className="t">{v.t}</span><br /><span className="s">{v.s}</span></span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
